import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'

const initialState = {
    input: {},
    rtp_level_list: {},
    isLoading: false,
    dialogOpen: false,
    type: ''
}

class EditRiskLabelConfirmMsgDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EditRiskLabelConfirmMsgDialog', options)
        }
        this.state = initialState
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    OpenDialog(inputs, type) {
        this.setState({
            input: inputs,
            type,
            isLoading: false,
        })
        this.queryData()
        this.setState({ dialogOpen: true })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    confirm() {
        if (this.props.confirmCallback) {
            this.props.confirmCallback()
        }
        this.closeDialog()
    }

    queryData = (queryParams) => {
        utils.apiRequest(
            'get',
            API.RISKMGT_RTP_LEVEL_LIST,
            queryParams,
            (data) => {
                this.setState({ rtp_level_list: data })
            },
            (_err) => { },
            true
        )
    }

    patchGameRtp() {
        const apiParams = {
            oid: this.state.input.oid,
            pf_sub_pf_id: this.state.input.pfSubPfIDList,
            rtp_level: this.state.input.rtp_level,
            is_buy_slot_game: false
        }

        if (this.state.type === 'feature') {
            apiParams.is_buy_slot_game = true
        }
        
        utils.apiRequest(
            'put',
            API.RISKMGT_GAME_RISK_INFO_RTP,
            apiParams,
            (_data) => {
                this.confirm()
            },
            (_err) => {
                this.setState({ isLoading: false })
            }
        )
    }

    patchRtp() {
        const apiParams = {
            id: this.state.input.id,
            rtp_level: this.state.input.rtp_level,
        }

        utils.apiRequest(
            'patch',
            API.RISKMGT_GAME_RISK_INFO,
            apiParams,
            (_data) => {
                this.confirm()
            },
            (_err) => {
                this.setState({ isLoading: false })
            }
        )
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>
                    {this.t(this.state.type === 'rtp' ? 'Title': 'featureTitle', {
                        game_name: this.t('GameName.' + this.state.input.game_code),
                    })}
                </DialogTitle>
                <DialogContent>
                    {
                        <Typography>
                            {this.t(this.state.type === 'rtp' ? 'confirmSetRTPLevel': 'confirmSetFeatureBuyLevel', {
                                game_name: this.t('GameName.' + this.state.input.game_code),
                                rtp_level: this.state.input.rtp_level,
                            })}
                        </Typography>
                    }
                    {this.state.input.pf_sub_pf_id === 'public' && <Typography color="error">{this.t('confirmSetRTPLevelComment')}</Typography>}
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.setState({ isLoading: true })
                            this.props.useGameAdmin ? this.patchGameRtp() : this.patchRtp()
                        }}
                        color="primary"
                        disabled={this.state.isLoading}>
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {}
}

EditRiskLabelConfirmMsgDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
    useGameAdmin: PropTypes.bool
}

export default hoc(styles)(EditRiskLabelConfirmMsgDialog)
